import { RichText } from "@/components/RichText";
import type { GrindItem } from "@/lib/types";

interface Props {
  data: { eyebrow: string; title: string; sub: string; items: GrindItem[] };
}

export default function Grind({ data }: Props) {
  return (
    <section className="grind">
      <div className="grind-inner">
        <div className="section-header">
          <span className="section-eyebrow">{data.eyebrow}</span>
          <RichText as="h2" className="section-title" html={data.title} />
          <p className="section-sub">{data.sub}</p>
        </div>
        <div className="grind-list">
          {data.items.map((item) => (
            <div className="grind-item" key={item.num}>
              <span className="grind-num">{item.num}</span>
              <h3 className="grind-title">{item.title}</h3>
              <p className="grind-body">{item.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
